import { SignIn } from "components";
import { useNavigate } from "react-router-dom";
import { ROUTE_KEYS } from "keys";

export const SignInPage = () => {
  const navigate = useNavigate();

  return <SignIn onSignIn={() => navigate(ROUTE_KEYS.ACCOUNT_DETAILS)} />;
};
